import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { InputContainer, Modal, SendToast, Text } from "@networkraildigitalfactory/components";
import emojiStrip from "emoji-strip";
import { useObjectives, usePDP } from "../../../hooks/useAPI";
import { a11yGrowTextarea } from "../../../services/utils";
import { getPropsByAction } from "./inputHelpers";
import styles from "./InputModal.module.css";
import useDisableScroll from "../../../hooks/useDisableScroll";

const InputModal = (props) => {
  const { redirect, action, objectiveId, pdpId, isLineManager, close, show, type } = props;
  const { register, handleSubmit, errors } = useForm();
  const history = useHistory();
  const selectedId = objectiveId || pdpId;

  const modalProps = getPropsByAction(action, type, redirect);
  const { status, toast, navTo, confirmText, focusOnClose, heading, message, message2, inputName } =
    modalProps;

  const [{ error: objectiveActionError }, executeObjectivePut] = useObjectives(
    {
      url: selectedId,
      method: "PUT",
    },
    { manual: true }
  );

  const [{ error: pdpActionError }, executePdpPut] = usePDP(
    {
      url: selectedId,
      method: "PUT",
    },
    { manual: true }
  );

  const [inputModalValue, setInputModalValue] = useState();

  const onInputChange = (field, value) => {
    setInputModalValue((prevFormValues) => ({
      ...prevFormValues,
      [field]: emojiStrip(value),
    }));
  };

  const onSubmit = async () => {
    inputModalValue.status = status;
    inputModalValue.isLineManager = isLineManager;
    if (type === "PDP") {
      await executePdpPut({
        data: inputModalValue,
      });
    } else {
      await executeObjectivePut({
        data: inputModalValue,
      });
    }
    if (objectiveActionError || pdpActionError) {
      SendToast(toast.error, "error");
    } else {
      close();
      history.push(navTo);
      SendToast(toast.success, "success");
    }
  };
  useDisableScroll(show);

  return (
    <Modal
      type="confirm"
      cancelText="Back"
      cancelButtonColor="red"
      confirmText={confirmText}
      show={show}
      onClose={close}
      onConfirm={handleSubmit(onSubmit)}
      style={{ maxWidth: "90%", width: "690px", top: "5vh", position: "fixed" }}
      focusOnClose={focusOnClose}
    >
      <Text wrapper="h1" type="header" style={{ marginBottom: "2rem" }}>
        {heading}
      </Text>
      <Text wrapper="p" type="body" color="#000000" style={{ marginBottom: !message2 && 0 }}>
        {message}
        {!message2 && <span className={styles.mandatory}> (mandatory field)</span>}
      </Text>
      {message2 && (
        <Text wrapper="p" type="body" color="#000000" style={{ marginBottom: 0 }}>
          {message2} <span className={styles.mandatory}> (mandatory field)</span>
        </Text>
      )}
      <InputContainer
        forLabel="currentFeedback"
        errorText={errors.currentFeedback && errors.currentFeedback.message}
      >
        <textarea
          name={inputName}
          className={`${styles.input} ${errors[inputName] && styles.error}`}
          type="text"
          ref={register({
            required: "Must not be blank",
          })}
          id="currentFeedback"
          onChange={(e) => onInputChange("currentFeedback", e.target.value, false)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onInputChange("currentFeedback", e.target.value, true);
            }
            a11yGrowTextarea(e, "currentFeedback");
          }}
        />
      </InputContainer>
    </Modal>
  );
};

export default InputModal;
